import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import axios from 'axios';

const Hero = () => {
  const [videoUrl, setVideoUrl] = useState('https://cdn.coverr.co/videos/coverr-bungee-jumping-8521/1080p.mp4');

  useEffect(() => {
    const fetchHeroVideo = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL || '';
        console.log('Fetching hero video from:', `${API}/api/videos`);
        const response = await axios.get(`${API}/api/videos`);
        console.log('Videos response:', response.data);
        
        // Find the active hero video
        const heroVideo = response.data.find(video => video.type === 'hero' && video.isActive);
        console.log('Found hero video:', heroVideo);
        
        if (heroVideo && heroVideo.url) {
          console.log('Setting hero video URL:', heroVideo.url);
          setVideoUrl(heroVideo.url);
        }
      } catch (error) {
        console.error('Failed to fetch hero video:', error);
        // Keep default video if fetch fails
      }
    };

    fetchHeroVideo();
  }, []);

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div className="relative h-[60vh] md:h-[85vh] overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video
          key={videoUrl}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          <source
            src={videoUrl}
            type="video/mp4"
          />
        </video>
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-4">
        <div className="text-center space-y-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tighter animate-zoom-in">
            JUMP. SCREAM.
          </h1>
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-200 tracking-tighter animate-zoom-in animation-delay-300">
            BUNGEEEE...
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Hero;